import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import libSanitizeHtml from 'sanitize-html';
function transformEquationImage(tagName, attribs) {
  return {
    tagName: tagName,
    attribs: _objectSpread(_objectSpread({}, attribs), {}, {
      src: "https://canvas.instructure.com".concat(attribs.src),
      style: 'vertical-align: middle'
    })
  };
}
function transformImage(tagName, attribs) {
  if (attribs.src != null && attribs.src.indexOf('/equation_images') === 0) {
    return transformEquationImage(tagName, attribs);
  }
  return {
    tagName: tagName,
    attribs: attribs
  };
}
export function sanitizeHtml(html) {
  return libSanitizeHtml(html, {
    allowedTags: false,
    allowedAttributes: false,
    transformTags: {
      img: transformImage
    }
  });
}